module.exports = __webpack_public_path__ + "img/eva-er-ikke-laengere-4.27c6d71e.png";